// Convenience functions that match the original API
import { SingleMaturityExportService } from './singleMaturityExportService';
import { MultiMaturityExportService } from './multiMaturityExportService';
import { MultiWithdrawalExportService } from './multiWithdrawalExportService';

// Excel Services
export { BaseExcelService } from './baseExcelService';
export { SingleMaturityExportService } from './singleMaturityExportService';
export { MultiMaturityExportService } from './multiMaturityExportService';
export { MultiWithdrawalExportService } from './multiWithdrawalExportService';
export { CreditCardExportService } from './creditCardExportService';
export { WithdrawalExportService } from './withdrawalExportService';

// Types and Constants
export type {
  ExcelCellStyle,
  MultiExportData,
  MultiWithdrawalExportData,
} from './types';
export { ExcelColors } from './types';

export const exportMaturityScheduleToExcel =
  SingleMaturityExportService.exportToExcel;
export const exportMultipleMaturitySchedulesToExcel =
  MultiMaturityExportService.exportToExcel;
export const exportMultipleWithdrawalTransactionsToExcel =
  MultiWithdrawalExportService.exportToExcel;
